<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.appFeedback.query.nickname')" prop="nickname">
                <a-input v-model="queryParam.nickname" :placeholder="$t('views.appFeedback.query.nicknamePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <!-- 联系方式
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.appFeedback.query.contact')" prop="contact">
                <a-input v-model="queryParam.contact" :placeholder="$t('views.appFeedback.query.contactPlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            -->

            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.appFeedback.query.processStatus')" prop="processStatus">
                <a-select v-model="queryParam.processStatus" :placeholder="$t('views.appFeedback.query.processStatusPlaceholder')">
                  <a-select-option :key="1">{{ $t('views.appFeedback.processStatus.pending') }}</a-select-option>
                  <a-select-option :key="2">{{ $t('views.appFeedback.processStatus.done') }}</a-select-option>
                  <a-select-option :key="3">{{ $t('views.appFeedback.processStatus.skipped') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <!--              <a-col :md="8" :sm="24">-->
              <!--                <a-form-item label="处理结果" prop="processResult">-->
              <!--                  <a-input v-model="queryParam.processResult" placeholder="请输入处理结果" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
              <!--              <a-col :md="8" :sm="24">-->
              <!--                <a-form-item label="反馈图片地址集合,JSONArray的字符串" prop="imgUrls">-->
              <!--                  <a-input v-model="queryParam.imgUrls" placeholder="请输入反馈图片地址集合,JSONArray的字符串" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.appFeedback.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.appFeedback.btn.reset') }}</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? '收起' : '展开' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['app:feedback:add']">-->
        <!--          <a-icon type="plus" />新增-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['app:feedback:edit']">-->
        <!--          <a-icon type="edit" />修改-->
        <!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['app:feedback:remove']" >
          <a-icon type="delete" />{{ $t('views.appFeedback.btn.delete') }}
        </a-button>
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['app:feedback:export']">-->
        <!--          <a-icon type="download" />导出-->
        <!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :bordered="tableBordered"
        :scroll="{ x: 2000 }"
      >
        <!--
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"-->
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="imgUrl" slot-scope="text, record">
          <template v-if="record.imgUrls">
            <img
              style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;"
              v-if="record.imgUrls"
              v-for="(img,imgIndex) in record.imgUrls.split(',')"
              v-image-preview
              :src="img"
              :preview="$t('views.appFeedback.img.previewFallback')"/>
          </template>
          <template v-else>{{ $t('views.appFeedback.img.notUploaded') }}</template>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-if="record.processStatus == 1" v-hasPermi="['app:feedback:audit']" />
          <a v-if="record.processStatus == 1" @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['app:feedback:audit']" >
            <a-icon type="edit" />{{ $t('views.appFeedback.btn.handle') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['app:feedback:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['app:feedback:remove']" >
            <a-icon type="delete" />{{ $t('views.appFeedback.btn.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageFeedback, listFeedback, delFeedback } from '@/api/app/feedback'

import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Feedback',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        nickname: null,
        type: null,
        content: null,
        processStatus: undefined,
        processResult: null,
        imgUrls: null,
        // contact: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: []
    }
  },
  filters: {
  },
  created () {
    this.initColumns()
    this.getList()
  },
  computed: {
  },
  watch: {
    '$i18n.locale' () {
      this.initColumns()
    }
  },
  methods: {
    paginationShowTotal (total) {
      return this.$t('views.appFeedback.pagination.total', { total })
    },
    initColumns () {
      const vm = this
      this.columns = [
        {
          title: this.$t('views.appFeedback.column.id'),
          dataIndex: 'id',
          width: 150,
          align: 'center'
        },
        {
          title: this.$t('views.appFeedback.column.nickname'),
          dataIndex: 'nickname',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('views.appFeedback.column.feedbackType'),
          dataIndex: 'feedbackType',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('views.appFeedback.column.content'),
          dataIndex: 'content',
          width: 320,
          align: 'center'
        },
        {
          title: this.$t('views.appFeedback.column.imgUrls'),
          dataIndex: 'imgUrls',
          width: 130,
          align: 'center',
          scopedSlots: { customRender: 'imgUrl' }
        },
        // {
        //   title: this.$t('views.appFeedback.column.contact'),
        //   dataIndex: 'contact',
        //   align: 'center'
        // },
        {
          title: this.$t('views.appFeedback.column.processStatus'),
          dataIndex: 'processStatus',
          width: 110,
          align: 'center',
          customRender: (t) => {
            if (t === 1 || t === '1') {
              return vm.$t('views.appFeedback.processStatus.pending')
            }
            if (t === 2 || t === '2') {
              return vm.$t('views.appFeedback.processStatus.done')
            }
            if (t === 3 || t === '3') {
              return vm.$t('views.appFeedback.processStatus.skipped')
            }
            return ''
          }
        },
        {
          title: this.$t('views.appFeedback.column.processResult'),
          dataIndex: 'processResult',
          width: 320,
          align: 'center'
        },
        {
          title: this.$t('views.appFeedback.column.processResultEn'),
          dataIndex: 'processResultEn',
          width: 320,
          align: 'center',
          customRender: (text, record) => {
            const v = record.processResultEn != null && record.processResultEn !== ''
              ? record.processResultEn
              : (record.process_result_en || '')
            return v || ''
          }
        },
        {
          title: this.$t('views.appFeedback.column.createTime'),
          dataIndex: 'createTime',
          width: 170,
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('views.appFeedback.column.operation'),
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    },
    /** 查询意见反馈列表 */
    getList () {
      this.loading = true
     pageFeedback(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        nickname: undefined,
        type: undefined,
        content: undefined,
        processStatus: undefined,
        processResult: undefined,
        imgUrls: undefined,
        // contact: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      const that = this
      const ids = row && row.id ? [row.id] : [...this.ids]
      if (!ids.length) {
        return
      }
      this.$confirm({
        title: that.$t('views.appFeedback.confirm.deleteTitle'),
        content: that.$t('views.appFeedback.confirm.deleteContent', { ids: String(ids) }),
        onOk () {
          const data = ids.map(id => ({ id }))
          return delFeedback(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.appFeedback.msg.deleteSuccess'),
                3
              )
            })
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('app/app-feedback/export', {
            ...that.queryParam
          }, `意见反馈_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
